import { render, staticRenderFns } from "./ModalControleAcessoQuartos.vue?vue&type=template&id=4a975dec&scoped=true&"
import script from "./ModalControleAcessoQuartos.vue?vue&type=script&lang=js&"
export * from "./ModalControleAcessoQuartos.vue?vue&type=script&lang=js&"
import style0 from "./ModalControleAcessoQuartos.vue?vue&type=style&index=0&id=4a975dec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a975dec",
  null
  
)

export default component.exports